<script setup lang="ts">
defineProps({
  content: {
    type: Object,
    required: true,
    default() {
      return {};
    },
  },
});
</script>
<template>
  <section
    class="banner flex justify-center items-center px-16 mt-7 w-full bg-primary max-md:px-5 max-md:max-w-full"
  >
    <div class="max-w-full w-[875px]">
      <div class="flex gap-5 max-md:flex-col max-md:gap-0">
        <div class="flex flex-col w-[81%] max-md:ml-0 max-md:w-full">
          <div class="flex flex-col mt-16 max-md:mt-10 max-md:max-w-full">
            <div
              class="flex gap-5 text-white max-md:flex-wrap max-md:max-w-full"
            >
              <h2
                class="grow self-start text-3xl font-semibold leading-10 text-right text-nowrap"
              >
                {{ content.heading }}
              </h2>
              <BaseRichText :content="content.content" />
            </div>
            <div class="flex gap-1.5 self-end mt-7 max-md:mr-2.5">
              <a :href="content.appStoreLink" rel="noopener noreferrer">
                <img
                  loading="lazy"
                  src="/icons/app-store.png"
                  alt="App Store badge"
                  class="shrink-0 w-40 max-w-full aspect-[2.63] cursor-pointer"
                />
              </a>
              <a :href="content.googlePlayLink" rel="noopener noreferrer">
                <img
                  loading="lazy"
                  src="/icons/google-play.png"
                  alt="Google Play badge"
                  class="shrink-0 w-40 max-w-full aspect-[2.63] cursor-pointer"
                />
              </a>
            </div>
          </div>
        </div>
        <div
          class="relative flex flex-col items-center ml-5 w-[19%] max-md:ml-0 max-md:w-full"
        >
          <img
            loading="lazy"
            src="/img/app-banner-img.png"
            alt="OnePass Mobile App screenshot"
            class="grow shrink-0 max-w-full aspect-[0.67] w-[150px] max-md:mt-10 -top-10"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped lang="scss">
.banner {
  :deep() {
    p {
      @apply text-2xl font-medium leading-8 font-semibold;
    }
  }
}
</style>
